import "./Card.css";

export default function Card({ children, style = {}, className = "" }) {
  return (
    <div className={"App-card " + className} style={style}>
      {children}
    </div>
  );
}
